import React from 'react';
import { ApSecondaryNav, ApButtonTab } from '@alixpartners/ui-components';
import { NavLink, useLocation } from 'react-router-dom';

export const BENCHMARK_NAV_CONFIG = [
	{
		name: 'spend-rations',
		label: 'Spend Ratios',
		path: '/benchmark/benchmarks',
	},
	{
		name: 'procurement-metrics',
		label: 'Procurement Metrics',
		path: '/spend/procurement-metrics',
	},
];

export const SecondaryNav = () => {
	const location = useLocation();

	return (
		<ApSecondaryNav
			left={BENCHMARK_NAV_CONFIG.map(({ label, path, disabled }) => (
				<NavLink to={path} key={path} disabled={disabled}>
					<ApButtonTab
						isSelected={location.pathname === path}
						disabled={disabled}
					>
						{label}
					</ApButtonTab>
				</NavLink>
			))}
		/>
	);
};

export default SecondaryNav;
